export interface ITsmSummary {
  owner_id?: number | null;
  pcp_tin?: string | null;
  completed?: number | null;
  missing?: number | null;
  open?: number | null;
  rank?: number | null;
  rank_of?: number | null;
  star?: number | null;
  today_completed_wa?: number | null;
  today_messed_woa?: number | null;
  today_rank?: number | null;
  today_rank_of?: number | null;
  today_star?: number | null;
  today_date?: string | null;
  mco?: number | null;
  member_name?: number | null;
  dob?: number | null;
  member_phone1?: number | null;
  measure_code?: number | null;
  deadline_calculation?: number | null;
  diagnosis_code?: number | null;
}

export class TsmSummary implements ITsmSummary {
  owner_id?: number | null;
  pcp_tin?: string | null;
  completed?: number | null;
  missing?: number | null;
  open?: number | null;
  rank?: number | null;
  rank_of?: number | null;
  star?: number | null;
  today_completed_wa?: number | null;
  today_messed_woa?: number | null;
  today_rank?: number | null;
  today_rank_of?: number | null;
  today_star?: number | null;
  today_date?: string | null;
  mco?: number | null;
  member_name?: number | null;
  dob?: number | null;
  member_phone1?: number | null;
  measure_code?: number | null;
  deadline_calculation?: number | null;
  diagnosis_code?: number | null;

  constructor(data: ITsmSummary) {
    Object.assign(this, data);
  }

  static fromObject(data: ITsmSummary): TsmSummary {
    return new TsmSummary(data);
  }

  static fromObjectArray(data: ITsmSummary[]): TsmSummary[] {
    return data.map(TsmSummary.fromObject);
  }
}

export interface IResultTsmSummary {
  count: number;
  next: string | null;
  previous: string | null;
  results: ITsmSummary[];
}

export class ResultTsmSummary implements IResultTsmSummary {
  count: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: TsmSummary[] = [];

  constructor(data?: IResultTsmSummary) {
    if (data) {
      this.count = data.count;
      this.next = data.next;
      this.previous = data.previous;
      this.results = data.results ? TsmSummary.fromObjectArray(data.results) : [];
    }
  }

  static fromObject(data: IResultTsmSummary): ResultTsmSummary {
    return new ResultTsmSummary(data);
  }
}
